import React from "react";
// import ProtectedRoute from "../Protected Routes/ProtectedRoute";
import Dashboard from "../pages/Dashboard/Dashboard";
import Causes from "../pages/Cause/Causes";
import Volunteers from "../pages/Volunteers";
import Analytics from "../pages/Analytics";
// import AdminLayout from "../components/AdminLayout";
import Layout from "../Layout copy/MainLayout";
import AllCauses from "../pages/Cause/AllCauses";
import FraudMarked from "../pages/Cause/FraudMarked";
import DonationList from "../pages/Donations/DonationList";
import FundTransferList from "../pages/Donations/FundTransferList";
import Donations from "../pages/Donations/Donations";
import UsersList from "../pages/Users/UsersList";
import VolunteerApproved from "../pages/Users/VolunteerApproved";
import VolunteerPending from "../pages/Users/VolunteerPending";
import Publishedcause from "../pages/Cause/Publishedcause";
import Finishedcause from "../pages/Cause/Finishedcause";
import Reordercause from "../pages/Cause/Reordercause";
import Settings from "../pages/Setting/Setting";
import CauseDetails from "../pages/Cause/CauseDetails";

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  element: <Layout />,
  children: [
    {
      path: "/Dashboard",
      element: <Dashboard />,
    },
    {
      path: "/volunteers",
      element: <Volunteers />,
    },
    {
      path: "/causes",
      element: <Causes />,
    },
    {
      path: "/allcauses",
      element: <AllCauses />,
    },
    {
      path: "/finishedcause",
      element: <Finishedcause />,
    },
    {
      path: "/reordercause",
      element: <Reordercause />,
    },
    {
      path: "/Publishedcause",
      element: <Publishedcause />,
    },
    {
      path: "/donation",
      element: <Donations />,
    },
    {
      path: "/donationlist",
      element: <DonationList />,
    },
    {
      path: "/fundtransfers",
      element: <FundTransferList />,
    },
    {
      path: "/users",
      element: <UsersList />,
    },
    {
      path: "/volunteers",
      element: <VolunteerApproved />,
    },
    {
      path: "/pendingvolunteers",
      element: <VolunteerPending />,
    },
    {
      path: "/analytics",
      element: <Analytics />,
    },
    {
      path: "/cause-details",
      element: <CauseDetails />,
    },
    {
      path: "/setting",
      element: <Settings />,
    },
  ],
};

// const MainRoutesWithProtection = {
//   element: <MainLayout />,
//   children: MainRoutes.children.map((route) => ({
//     ...route,
//     element: <ProtectedRoute>{route.element}</ProtectedRoute>,
//   })),
// };

export default MainRoutes;
